/* ChatGPT Ads events — Add to Cart, Begin Checkout, Lead. Managed by UnfoldCRO. */
(function () {
  if (window.__oaiEventsLoaded) return; window.__oaiEventsLoaded = true;
  var CART_JS = (window.theme && theme.routes && theme.routes.cart_url) ? (theme.routes.cart_url + ".js") : "/cart.js";
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var state = { cart: window.OAI_CART || null };
  var CHECKOUT_SELECTOR = '[name="checkout"], a[href^="/checkout"], a[href*="/checkout?"], [data-oai-checkout]';
  var DEFAULT_CALLING_CODE = "91"; /* India: local numbers get +91 before hashing */

  function q(){ if(window.oaiq) window.oaiq.apply(null, arguments); }
  function toContent(item, quantity) {
    return { id: String(item.product_id || item.id), name: item.product_title || item.title,
      content_type: "product", quantity: quantity,
      amount: Math.round(item.final_price != null ? item.final_price : item.price), currency: window.OAI_CURRENCY };
  }
  function parseQty(init){ var qn={}; var b=init&&init.body; if(!b) return qn;
    try{
      if(typeof FormData!=="undefined"&&b instanceof FormData){ qn[String(b.get("id"))]=parseInt(b.get("quantity"),10)||1; }
      else if(typeof b==="string"&&b.charAt(0)==="{"){ var p=JSON.parse(b); if(Array.isArray(p.items)){p.items.forEach(function(i){qn[String(i.id)]=parseInt(i.quantity,10)||1;});} else {qn[String(p.id)]=parseInt(p.quantity,10)||1;} }
      else if(typeof b==="string"){ var pr=new URLSearchParams(b); qn[String(pr.get("id"))]=parseInt(pr.get("quantity"),10)||1; }
    }catch(e){ return qn; } return qn; }

  /* Prices come from /cart.js (correct minor units) — the /cart/add response is
     rewritten to major units by the checkout app on this store, so never trust it for amount. */
  function measureAdded(items, requested){
    if(!nativeFetch){ return; }
    nativeFetch(CART_JS,{credentials:"same-origin"}).then(function(r){return r.json();}).then(function(cart){
      state.cart = cart;
      var unitByVar={}; (cart.items||[]).forEach(function(li){ unitByVar[String(li.variant_id)]=li.price; });
      var contents=items.map(function(it){ var vid=String(it.variant_id||it.id);
        var unit = unitByVar[vid]!=null ? unitByVar[vid] : Math.round(it.final_price!=null?it.final_price:it.price);
        var qty=(requested&&requested[vid])||it.quantity||1;
        return { id:String(it.product_id||it.id), name:it.product_title||it.title, content_type:"product", quantity:qty, amount:unit, currency:window.OAI_CURRENCY };
      });
      var total=contents.reduce(function(s,c){return s+c.amount*c.quantity;},0);
      q("measure","items_added",{type:"contents",amount:total,currency:window.OAI_CURRENCY,contents:contents});
    }).catch(function(){});
  }
  function measureCheckout(){ var c=state.cart; if(!c||!c.items||!c.items.length) return;
    q("measure","checkout_started",{type:"contents",amount:Math.round(c.total_price),currency:c.currency||window.OAI_CURRENCY,
      contents:c.items.map(function(i){return toContent(i,i.quantity);})}); }
  function refreshCart(){ if(!nativeFetch) return; nativeFetch(CART_JS,{credentials:"same-origin"}).then(function(r){return r.json();}).then(function(c){state.cart=c;}).catch(function(){}); }

  if (nativeFetch) {
    window.fetch = function(input, init){
      var url = typeof input==="string"?input:(input&&input.url)||"";
      var pr = nativeFetch(input, init);
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      var isMut = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
      if (isMut) {
        var requested = isAdd ? parseQty(init) : null;
        pr.then(function(res){ if(!res||!res.ok) return;
          if(isAdd){ res.clone().json().then(function(p){ var items=Array.isArray(p.items)?p.items:[p]; measureAdded(items,requested); }).catch(function(){ measureAdded([], requested); }); }
          else { refreshCart(); }
        }).catch(function(){});
      }
      return pr;
    };
  }
  document.addEventListener("click", function(e){ var t=e.target&&e.target.closest?e.target.closest(CHECKOUT_SELECTOR):null; if(t) measureCheckout(); }, true);

  /* ---- Lead (hashed advanced matching) ---- */
  function sha256Hex(v){ var b=new TextEncoder().encode(v); return crypto.subtle.digest("SHA-256",b).then(function(buf){ return Array.prototype.map.call(new Uint8Array(buf),function(x){return ("0"+x.toString(16)).slice(-2);}).join(""); }); }
  function email(v){ return String(v||"").trim().toLowerCase(); }
  function phone(v){ var d=String(v||"").replace(/[\s().\-]/g,"").replace(/^\+/,"").replace(/^0+/,""); if(DEFAULT_CALLING_CODE&&d.length<=10) d=DEFAULT_CALLING_CODE+d; return /^\d{8,15}$/.test(d)?d:""; }
  function nm(v){ return String(v||"").toLowerCase().replace(/[\s!-\/:-@\[-`{-~]/g,""); }
  function once(k){ try{ if(sessionStorage.getItem(k)) return true; sessionStorage.setItem(k,"1"); }catch(e){ return false; } return false; }

  window.oaiLead = function(fields){
    var f=fields||{}, user={}, jobs=[];
    var em=email(f.email), ph=phone(f.phone), parts=String(f.name||"").trim().split(/\s+/);
    var fn=nm(f.firstName||parts[0]), ln=nm(f.lastName||(parts.length>1?parts[parts.length-1]:""));
    if(em) jobs.push(sha256Hex(em).then(function(h){user.email_sha256=h;}));
    if(ph) jobs.push(sha256Hex(ph).then(function(h){user.phone_number_sha256=h;}));
    if(fn) jobs.push(sha256Hex(fn).then(function(h){user.first_name_sha256=h;}));
    if(ln) jobs.push(sha256Hex(ln).then(function(h){user.last_name_sha256=h;}));
    function send(){ q("measure","lead_created",{type:"customer_action"}); }
    Promise.all(jobs).then(function(){
      var fp="oai_lead:"+(user.email_sha256||user.phone_number_sha256||"anon");
      if(once(fp)) return;
      if(Object.keys(user).length) q("init",{pixelId:window.OAI_PIXEL_ID,user:user});
      send();
    }).catch(send);
  };

  document.addEventListener("submit", function(e){ var form=e.target; if(!form||!form.hasAttribute||!form.hasAttribute("data-oai-lead")) return;
    var val=function(sel){ var el=form.querySelector(sel); return el?el.value:""; };
    window.oaiLead({ email: val('input[type="email"], input[name*="email"]'), phone: val('input[type="tel"], input[name*="phone"]'), name: val('input[name*="name"]') });
  });
})();

/* ChatGPT ad-click attribution — save __oppref/__obref to cart so the order carries them (server-side CAPI). Managed by UnfoldCRO. */
(function () {
  function cookie(n){ var m=document.cookie.match(new RegExp("(?:^|; )"+n.replace(/([.*+?^${}()|[\]\\])/g,"\\$1")+"=([^;]*)")); return m?decodeURIComponent(m[1]):""; }
  function save(){
    var opp=cookie("__oppref"), obr=cookie("__obref");
    if(!opp && !obr) return;
    try{ if(sessionStorage.getItem("oai_attr_saved")==="1") return; }catch(e){}
    var base=(window.theme&&theme.routes&&theme.routes.cart_url)?theme.routes.cart_url:"/cart";
    fetch(base+"/update.js",{method:"POST",headers:{"Content-Type":"application/json"},credentials:"same-origin",
      body:JSON.stringify({attributes:{oai_oppref:opp,oai_obref:obr}})})
      .then(function(){ try{sessionStorage.setItem("oai_attr_saved","1");}catch(e){} }).catch(function(){});
  }
  window.addEventListener("load", function(){ setTimeout(save, 1500); });
})();
